// Third-party
import React from 'react';

// Components
import { SelectInput, SelectOption } from '../../components/inputs';
import ComparisonSettingsOptions from './ComparisonSettingsOptions';

// Utils
import { LOCALE_OPTIONS as localeOptions, FormattedMessage, formatMessage } from '@/utils/i18n';
import User from '@/types/user';
import Locale from '@/types/locale';
import UserPreferencesComparisonSettings from '@/types/user-preferences-comparison-settings';

type Props = {
  user: User;
  locale: Locale;
  delegateMode: boolean;
  comparisonSettings: UserPreferencesComparisonSettings;
  onLocaleChange: (locale: Locale) => void;
  onComparisonSettingsChange: (option: { [key: string]: string }) => void;
};

const LegacySettingsPreferences: React.FC<Props> = ({ user, locale, delegateMode, comparisonSettings, onLocaleChange, onComparisonSettingsChange }) => {
  const filteredLocales = localeOptions.filter(localeOption => user.appConfig.appLocales.includes(localeOption.value));

  return (
    <div className="settings-preferences settings-tab" data-testid="legacy-settings-preferences">
      <div className="preferences">
        <div className="preference">
          <FormattedMessage tagName="h3" id="Settings.Preferences.General.Title" />
        </div>
        <div className="options">
          <SelectInput label={formatMessage('Settings.Preferences.General.Fields.Language.Label')} onValueChange={onLocaleChange} selected={locale}>
            {filteredLocales.map(localeOption => (
              <SelectOption key={localeOption.value} value={localeOption.value}>
                {localeOption.label}
              </SelectOption>
            ))}
          </SelectInput>
        </div>
      </div>

      {!delegateMode && (
        <ComparisonSettingsOptions user={user} comparisonSettings={comparisonSettings} onComparisonSettingsChange={onComparisonSettingsChange} />
      )}
    </div>
  );
};

export default LegacySettingsPreferences;
